import React, {Fragment,Component} from "react";
import axios from "axios";
import exportToExcel from "../utils/ExcelUtils";

class NAB_LeadTrackingRow extends Component{
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            apiDetail: '/api/bankportal/report/detail/lead/nab',
            reportName: 'NAB_ReportLeadTracking',
        }
        this.onCLickToExport = this.onCLickToExport.bind(this);
        this.exportToExcel = exportToExcel.bind(this);
        this.handlerClickNode = this.props.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }
    onCLickToExport = (item) => {
        const payload = {
            yyyymmdd: item?.yyyymmdd,
            code: item?.code,
            type: item?.type,
            parentId: item?.parentId
        }
        const { apiDetail, reportName } = this.state;
        this.handlerSetIsLoading(true);
        axios.post(apiDetail, payload)
            .then(response => {
                let data = [];
                if(!!response.data){
                    data.push([
                        "Ngày báo cáo"
                        ,"Mã số lead"
                        ,"Cập nhật tình trạng"
                        ,"Mã số FSC"
                        ,"Mã NVNH(FWD)"
                        ,"Mã NVNH(Ngân hàng)"
                        ,"Tên NVNH"
                        ,"Tên chi nhánh"
                        ,"Mã số chi nhánh (FWD)"
                        ,"Mã chi nhánh (Ngân hàng)"
                        ,"Tên phòng giao dịch"
                        ,"Mã phòng giao dịch (FWD)"
                        ,"Mã phòng giao dịch (Ngân hàng)"
                        ,"Tên khách hàng khách hàng"
                        ,"Ngày sinh khách hàng"
                        ,"CMND/Passport"
                        ,"Số điện thoại khách hàng"
                        ,"Địa chỉ email khách hàng"
                        ,"Hình thức tiếp cận khách hàng"
                        ,"Khách hàng có đồng ý nhận tư vấn sản phẩm bảo hiểm"
                        ,"Khách hàng có bảo hiểm chưa"
                        ,"Ngày tạo lead"
                        ,"Ngày FSC nhận lead/mở lead"
                        ,"Ghi chú về đối tượng khách hàng"
                        ,"Ngày gọi"
                        ,"Cập nhật tình trạng tư vấn (có gặp được khách hàng hay không)"
                        ,"Số lần gọi"
                        ,"Ngày gọi thứ nhất"
                        ,"Ngày gọi thứ hai"
                        ,"Ngày gọi tiếp theo"
                        ,"Ngày gặp tư vấn"
                        ,"Kết quả hẹn gặp"
                        ,"Tổng số lần gặp"
                        ,"Ngày gặp thứ nhất"
                        ,"Ngày gặp thứ hai"
                        ,"Ngày gặp tiêp theo"
                        ,"Ngày gửi email"
                        ,"Tình  trạng gửi email"
                        ,"Ghi chú"
                        ,"Ngày tư vấn"
                        ,"Kết quả tư vấn"
                        ,"Ngày chốt Hợp đồng"
                        ,"Tình trạng chốt hợp đồng"
                        ,"Số hợp đồng"
                        ,"Nguồn khách hàng từ NVNH giới thiệu"
                        ,"Mã người giới thiệu"
                        ,"Mã lãnh đạo phòng"
                    ]);
                    response?.data.map(item =>
                        data.push([
                            item?.reportDate
                            ,item?.refNo
                            ,item?.status
                            ,item?.fscCode
                            ,item?.bsCode
                            ,item?.bsCodeBank
                            ,item?.bsName
                            ,item?.boName
                            ,item?.boCode
                            ,item?.boCodeBank
                            ,item?.toName
                            ,item?.toCode
                            ,item?.toCodeBank
                            ,item?.poName
                            ,item?.poBirthday
                            ,item?.poId
                            ,item?.poMobile
                            ,item?.poEmail
                            ,item?.approach
                            ,item?.allowToContact
                            ,item?.existPolicy
                            ,item?.createDate
                            ,item?.receiveDate
                            ,item?.note
                            ,item?.callDate
                            ,item?.callResult
                            ,item?.callTimes
                            ,item?.call1Date
                            ,item?.call2Date
                            ,item?.call3Date
                            ,item?.meetDate
                            ,item?.meetResult
                            ,item?.meetTimes
                            ,item?.meet1Date
                            ,item?.meet2Date
                            ,item?.meet3Date
                            ,item?.mailDate
                            ,item?.mailResult
                            ,item?.otherNote
                            ,item?.presentDate
                            ,item?.presentResult
                            ,item?.contractDate
                            ,item?.contractResult
                            ,item?.policyNumber
                            ,item?.leadSource
                            ,item?.introducerHrm
                            ,item?.hrm
                        ])
                    )
                }

                const exportName = item?.yyyymmdd+'_'+item?.code+'_'+item?.name+'_'+reportName;
                this.exportToExcel(data, exportName);
                this.handlerSetIsLoading(false);
            })
            .catch(error => {
                this.setState({ errorMessage: error.message });
                console.error('There was an error!', error);
                this.handlerSetIsLoading(false);
            });
    }
    render() {
        const {hasChild,isExpanded,marginLeftValue,data} = this.props;
        const iconStyle = {
            marginLeft: marginLeftValue+'px',
            boxShadow: 'none'
        }
        return (
            <Fragment>
            {
                !!data &&
                    <tr>
                        <td className={'bp-report-tree-node'}>
                            <button style={iconStyle} type="button" className={"btn"} onClick={this.handlerClickNode}>
                                {
                                    hasChild ?isExpanded?(' - '):(' + '):('   ')
                                }
                            </button>
                            <span>{ data?.name }</span>
                        </td>
                        <td className={"bp-report-td"}><span> { data?.c_refer?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_meet?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_advisor?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_close?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_refer_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_meet_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_advisor_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_close_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_refer_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_meet_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_advisor_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_close_ytd?.toLocaleString() } </span></td>
                        <td className={'bp-report-button-export'}>
                            <button onClick={ () => this.onCLickToExport(data) } className={"btn btn-sm btn-info mt-1"}>Chi tiết</button>
                        </td>
                    </tr>

            }
            </Fragment>
        )
    }
}
export default NAB_LeadTrackingRow;